import createCachedSelector from 're-reselect'
import { emptyObj } from 'util/objects'
import { byProductCacheKey } from './byProductCacheKey'
import { selectLocalUsage } from './selectLocalUsage'

export const selectLocalUsageForProduct = createCachedSelector(
  selectLocalUsage,
  (_state, product) => product,
  (usage, product) => usage[product] || emptyObj
)(byProductCacheKey)
